import { create } from 'zustand';

import type { EventUIState } from './event-ui-store.type';

export const useEventUIStore = create<EventUIState>((set) => ({
  currentStep: '',
  scrollTargetId: null,
  forceOpenGroupId: null,
  setCurrentStep: (step) => set({ currentStep: step }),
  setScrollTargetId: (id) => set({ scrollTargetId: id }),
  setForceOpenGroupId: (id) => set({ forceOpenGroupId: id }),
}));
